import React, { FC } from 'react';
import { Caption, Icon, Stack } from '@mediahuis/chameleon-react';
import { Error } from '@mediahuis/chameleon-theme-wl/icons';
import { ErrorMessage } from 'formik';
import { useTranslation } from 'react-i18next';

import './formikErrorTooltip.css';

interface FormikErrorTooltipProps {
  fieldName: string;
}

export const FormikErrorTooltip: FC<FormikErrorTooltipProps> = ({ fieldName }) => {
  const { t } = useTranslation();

  return (
    <ErrorMessage
      name={fieldName}
      render={(errorMessage) => (
        <Stack className="error-tooltip mt-0" flexDirection="row" data-cy={`${fieldName}-message`}>
          <Icon as={Error} size="sm" className="mr-1" />
          <Caption size="lg" className="red-base m-0">
            {t(errorMessage)}
          </Caption>
        </Stack>
      )}
    />
  );
};
